export const tableHeaders = (isAuVisible = false) => [
  {
    id: 1,
    label: 'Participant Name',
    intlKey: 'table.participant_name',
    sortableId: false// 'participant.lastName'
  },
  {
    id: 2,
    label: 'Award Unit',
    intlKey: 'table.award_unit',
    hide: !isAuVisible
  },
  {
    id: 3,
    label: 'Status',
    intlKey: 'table.status',
    sortable: false
  },
  {
    id: 4,
    label: 'Physical Recreation',
    intlKey: 'table.physical_activity',
    sortableId: false
  },
  {
    id: 5,
    label: 'Skills',
    intlKey: 'table.skills_activity',
    sortable: false
  },
  {
    id: 6,
    label: 'Voluntary Service',
    intlKey: 'table.service_activity',
    sortable: false
  },
  {
    id: 7,
    label: 'Practice Journey',
    intlKey: 'table.aj_practice',
    sortable: false
  },
  {
    id: 8,
    label: 'Qualifying Journey',
    intlKey: 'aj.qualifying_journey',
    sortable: false
  },
  {
    id: 9,
    label: 'Gold Residential Project',
    intlKey: 'table.rp',
    sortable: false
  }
]
